export default __webpack_public_path__ + "static/media/divineblessing.0e3bc3f7.png";